

(function messagesServiceDefinition() {

    'use strict';

    angular.module('Messages')
        .provider('messages', function messagesProvider() {

            this.$get = [
                'alerts', '$translate', '$q', function messagesFactory(alerts, $translate, $q) {

                    function titleByType(type) {
                        switch (type) {
                            case 'error':
                                return 'ErrorTitle';
                            case 'warning':
                                return 'ErrorWarningTitle'
                            case 'info':
                                return 'ErrorInfoTitle';
                            case 'success':
                                return 'ErrorSuccessTitle';
                            case 'input':
                                return 'ErrorInputTitle';
                            case 'prompt':
                                return 'ErrorPromptTitle';
                            default:
                        }
                    }

                    return {
                        showConfirm: function (text, title, yes, no, params) {
                            var deferred = $q.defer();

                            $translate([title || 'ErrorConfirmTitle', text, yes || 'ErrorConfirmYes', no || 'ErrorConfirmNo'], params)
                                .then(function (translated) {
                                    alerts.confirm(translated[title || 'ErrorConfirmTitle'],
                                            translated[text],
                                            translated[yes || 'ErrorConfirmYes'],
                                            translated[no || 'ErrorConfirmNo'])
                                        .then(function (confirmRes) {
                                            deferred.resolve(confirmRes);
                                        }, function () {
                                            deferred.reject();
                                        });
                                }, function () {
                                    deferred.reject();
                                });

                            return deferred.promise;
                        },
                        showSuccess: function(text, title, params) {
                            return $translate([title || 'ErrorSuccessTitle', text, 'ErrorOk'], params)
                                .then(function(translated) {
                                    return alerts.alert(translated[title || 'ErrorSuccessTitle'],
                                        translated[text],
                                        translated.ErrorOk,
                                        'success');
                                });
                        },
                        show: function statusCodeError(text, statusOrType, params) {
                            if (statusOrType === 401)
                                return;

                            var deferred = $q.defer();

                            if (statusOrType === 404) {
                                $translate(['ErrorTitle', 'NotFound', 'ErrorOk'], params).then(function (translated) {
                                    alerts.alert(translated.ErrorTitle,
                                        translated.NotFound,
                                        translated.ErrorOk,
                                        "error");
                                    deferred.resolve(true);
                                });
                            } else if (statusOrType === 403) {
                                $translate(['ErrorTitle', 'Forbidden', 'ErrorOk'], params).then(function (translated) {
                                    alerts.alert(translated.ErrorTitle,
                                        translated.Forbidden,
                                        translated.ErrorOk,
                                        "error");
                                    deferred.resolve(true);
                                });
                            } else {
                                var type = typeof statusOrType === "string" ? statusOrType : 'error';
                                var title = titleByType(type);

                                if (text === null || text === undefined) {
                                    $translate([titleByType(type), 'APIError', 'ErrorOk'], params).then(function (translated) {
                                        alerts.alert(translated[title],
                                            translated.APIError,
                                            translated.ErrorOk,
                                            type);
                                        deferred.resolve(true);
                                    });
                                } else {
                                    $translate([title, text, 'ErrorOk'], params)
                                        .then(function(translated) {
                                            alerts.alert(translated[title],
                                                translated[text],
                                                translated.ErrorOk,
                                                type);
                                            deferred.resolve(true);
                                        });
                                }
                            }
                            return deferred.promise;
                        },
                        showStatus: function(status) {
                            return this.show(null, status);
                        },
                        showCode: function (code, text, status, params) {
                            if (status === 401)
                                return;
                            var deferred = $q.defer();
                            if (code) {
                                var codeText = text + '_' + code;
                                $translate(['ErrorTitle', codeText, text, 'ErrorOk'], params)
                                    .then(function(translated) {

                                        var alertText = translated[codeText] || translated[text];

                                        if (alertText || !status) {
                                            alerts.alert(translated.ErrorTitle,
                                                alertText,
                                                translated.ErrorOk,
                                                "error");
                                        } else {
                                            this.showStatus(status);
                                        }
                                        deferred.resolve(true);
                                    });
                            } else if (text) {
                                this.show(text, 'error');
                            } else if (status) {
                                this.show(null, status);
                            } else {
                                this.show(null, 'error');
                            }
                            return deferred.promise;
                        }
                    };

                }
            ];
        });
})();